import Image from "next/image";
import { ShieldCheck } from "lucide-react";
import { AGENT } from "@/lib/seo";
import { WhatsAppButton } from "../WhatsAppButton";

export function ProjectAgentCard({ projectName }: { projectName: string }) {
  return (
    <div className="rounded-2xl border border-line bg-surface p-5 md:p-6">
      <div className="flex items-center gap-4">
        <div className="relative size-20 shrink-0 overflow-hidden rounded-full border-2 border-white bg-white shadow-sm">
          <Image src="/winnie-lim-headshot.png" alt={AGENT.name} fill className="object-cover object-top" />
        </div>
        <div>
          <h3 className="font-display text-xl font-semibold text-ink">{AGENT.name}</h3>
          <p className="mt-1 flex items-center gap-1.5 text-xs font-medium text-brand-700">
            <ShieldCheck aria-hidden="true" className="size-4" />
            CEA {AGENT.ceaRegNo} · {AGENT.estateAgent} {AGENT.ceaLicenceNo}
          </p>
        </div>
      </div>
      <p className="mt-5 max-w-[65ch] text-sm leading-6 text-ink-muted">
        Winnie combines licensed property advice with a data-led view of pricing, unit selection and the buying process.
      </p>
      <div className="mt-5 sm:w-fit">
        <WhatsAppButton
          text={`Hi Winnie, I am looking at ${projectName} on AI Property`}
          label="WhatsApp Winnie"
        />
      </div>
    </div>
  );
}
